<template>
  <div>
    <b-card no-body v-if="sourcesReport">
      <b-card-header>
        <h3 class="mb-0">Team Lead Source Report</h3>
        <b-row class="mt-3">
          <b-col md="4">
            <base-input label="Sale Type" label-for="saleType">
              <el-select v-model="type">
                <el-option v-for="type in types"
                           :key="type.value"
                           :label="type.label"
                           :value="type.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
          <b-col md="8">
            <label class="form-control-label">Date Range</label>
            <b-input-group>
              <template #prepend>
                <b-dropdown variant="outline-danger">
                  <template #button-content>
                    {{ rangeTitle }}
                  </template>
                  <b-dropdown-item v-for="item in ranges" :key="item.value" @click="range = item.value">{{ item.label }}</b-dropdown-item>
                </b-dropdown>
              </template>
              <b-form-datepicker v-model="start_date" locale="en" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
              <b-form-datepicker v-model="end_date" locale="en" :min="start_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-header>
      <b-table id="sources-report" responsive small :items="sourcesReport" :fields="fields" no-sort-reset v-if="sourcesReport.length > 0">
        <template #cell(source)="row">
          <span v-if="row.item.source">
            {{ row.item.source }}
          </span>
          <span v-else>
            <strong>No Source</strong>
          </span>
        </template>
        <template #cell(pending_volume)="row">
          {{ row.item.pending_volume | currency }}
        </template>
        <template #cell(pending_gci)="row">
          {{ row.item.pending_gci | currency }}
        </template>
        <template #cell(pending_gross_profit)="row">
          {{ row.item.pending_gross_profit | currency }}
        </template>
        <template #cell(closed_volume)="row">
          {{ row.item.closed_volume | currency }}
        </template>
        <template #cell(closed_gci)="row">
          {{ row.item.closed_gci | currency }}
        </template>
        <template #cell(closed_gross_profit)="row">
          {{ row.item.closed_gross_profit | currency }}
        </template>
        <template #cell(total_volume)="row">
          {{ row.item.total_volume | currency }}
        </template>
        <template #cell(total_gci)="row">
          {{ row.item.total_gci | currency }}
        </template>
        <template #cell(total_gross_profit)="row">
          {{ row.item.total_gross_profit | currency }}
        </template>
      </b-table>
      <div v-else>
        <h4 class="text-uppercase text-center text-muted my-4">There are no transactions for this date range.</h4>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import {Select, Option} from 'element-ui'

export default {
  mixins: [errorsMixin],
  props: {
    userRoute: null
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      sourcesReport: null,
      start_date: new Date(new Date().getFullYear(), 0, 1),
      end_date: new Date(new Date().getFullYear(), 11, 31),
      range: 0,
      ranges: [
        { value: 0, label: "Current Year" },
        { value: 1, label: "Yesterday" },
        { value: 2, label: "Last 7 Days" },
        { value: 3, label: "Current Month" },
        { value: 4, label: "Last 3 Months" },
      ],
      types: [
        { value: '', label: "All Sale Types" },
        { value: 'Listing', label: "Listing" },
        { value: 'Buyer', label: "Buyer" }
      ],
      type: '',
      fields: [
        {
          key: 'source',
          sortable: true
        },
        {
          key: 'pending_units',
          sortable: true
        },
        {
          key: 'pending_gci',
          sortable: true,
        },
        {
          key: 'pending_gross_profit',
          sortable: true,
        },
        {
          key: 'closed_units',
          sortable: true
        },
        {
          key: 'closed_gci',
          sortable: true,
        },
        {
          key: 'closed_gross_profit',
          sortable: true,
        },
        {
          key: 'total_units',
          sortable: true
        },
        {
          key: 'total_gci',
          sortable: true,
        },
        {
          key: 'total_gross_profit',
          sortable: true,
        },
      ],
    }
  },
  computed: {
    rangeTitle() {
      return this.ranges.filter((item) => {
        return item.value == this.range;
      })[0].label;
    },
  },
  methods: {
    async getSourcesReport() {
      let startDate = new Date(this.start_date).toLocaleDateString("en-US");
      let endDate = new Date(this.end_date).toLocaleDateString("en-US");

      axios.get(this.userRoute + "/reports/sources-report?start_date=" + startDate + "&end_date=" + endDate + "&sale_type=" + this.type)
      .then(response => {
        this.sourcesReport = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    updateRange() {
      switch(this.range) {
        case 0:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
          break;
        case 1:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 1))
          this.start_date = start_date;
          this.end_date = start_date;
          break;
        case 2:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 7))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 3:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - date.getDate() + 1))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 4:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 84))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        default:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
      }
    },
  },
  created() {
    this.getSourcesReport();
  },
  watch: {
    type(to, from) {
      this.getSourcesReport();
    },
    range(to, from) {
      this.updateRange();
    },
    start_date(to, from) {
      this.getSourcesReport();
    },
    end_date(to, from) {
      this.getSourcesReport();
    },
  }
};
</script>